import React, { FC } from 'react'

export const EyeDotted: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 6.667a4.167 4.167 0 1 1 0-8.334 4.167 4.167 0 0 1 0 8.334ZM10 3.75C5.95 3.75 2.316 6.25.833 10c1.992 5.067 7.708 7.55 12.775 5.558A9.831 9.831 0 0 0 19.166 10C17.683 6.25 14.05 3.75 10 3.75ZM5.833 18.333H7.5V20H5.833v-1.667Zm3.333 0h1.667V20H9.166v-1.667Zm3.334 0h1.666V20H12.5v-1.667ZM2.5 18.333h1.667V20H2.5zM15.833 18.333H17.5V20h-1.667z"
      fill="#000"
    />
  </svg>
)
